import { useCallback } from 'react';
import usePeriodView from 'src/hooks/usePeriodView';

const ManageGLCodeNote = () => {
  const { isBulkManageGLCode, handleBulkGLCodeAttribute, confirmBeforeProceedingToMainScreen } =
    usePeriodView();

  const handleClick = useCallback(() => {
    confirmBeforeProceedingToMainScreen(handleBulkGLCodeAttribute);
  }, [confirmBeforeProceedingToMainScreen, handleBulkGLCodeAttribute]);

  return (
    <div className="mt-2 text-sm">
      <div>
        {isBulkManageGLCode ? (
          <>
            <p className="mt-2">
              The current attribute statuses and assignments for the selected GL Codes appears
              below. Changes to GL Codes can be made here.
            </p>
            <p className="mt-2">
              Activating a rule requires at least one contact assignment. Only one attribute can be
              active per workflow. The approval rule applies only to 'Assigned' contacts. Select one
              or more contacts and use the arrows provided to change contact assignments. Click
              'Save' to apply assignment or rule changes to all selected GL Codes.
            </p>
          </>
        ) : (
          <>
            <p className="mt-2">
              The current attribute statuses and assignments for the selected GL Code appear below.
              Changes to a single GL Code can be made here. Click{' '}
              <span onClick={handleClick} className="text-link cursor-pointer underline">
                Bulk Manage GL Code Attributes{' '}
              </span>{' '}
              to update more than one code at a time.
            </p>
            <p className="mt-2">
              Activating a rule requires at least one contact assignment. Only one attribute can be
              active per workflow. The approval rule applies only to 'Assigned' contacts. Select one
              or more contacts and use the arrows provided to change contact assignments. Click
              'Save' to apply assignment or rule changes.
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default ManageGLCodeNote;
